<template>
  <!-- <div id="app">
    <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav>
    <router-view/>
  </div> -->
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
    <v-dialog v-model="dialog_update" persistent max-width="290">
        <v-card>
            <v-card-title class="pt-4 pl-4 pr-4" font-medium noshadow>Update Alert</v-card-title>
            <v-card-text class="pa-4">
                <div>
                    A new update is available. Would you like to reload the application?
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="blue darken-1" text @click="fn_closeDialogUpdate">Cancel</v-btn>
                <v-btn small color="blue darken-1" text @click.native="fn_refresApp">Refresh App</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
        dialog_update: false
    }
  },
  methods:{
    fn_closeDialogUpdate: function(){
        this.dialog_update = false;
        window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
    },

    fn_refresApp: function(){
        this.dialog_update = false;
        console.log("Reload Called");
        this.$root.fn_reloadApp();
    }

  },
  mounted(){
    var self = this;
    this.$eventHub.$on('updatefound', () => {
        window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
        window.js_globals.fn_onBackPress = self.fn_closeDialogUpdate;
        console.log('Version Updated');
        self.dialog_update = true;
    });
  }
}
</script>

<style>
  [center-align], .center-align{
    text-align: center;
  }
  [font-small], .font-small{
    font-size: small;
  }

  .theme--light.v-btn:hover::before,
  .theme--dark.v-btn:hover::before,
  .theme--light.v-tabs .v-tab--active:hover::before, 
  .theme--light.v-tabs .v-tab--active::before,
  .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header:hover:before{
      opacity: 0 !important;
  }
  .attendeelist_toolbar{
    position:sticky !important;
    top:0;
    z-index:9;
  }

  .gift_title{
    word-break: break-word !important;
    line-height: 20pt !important;
  }
  .attendeelist_customformatting {
    min-height: auto !important;
  }

  /* ======== backgrounds ============ */
  
  [light-blue], .light-blue{
        background: #90CAF9;
  }
  [light-pink], .light-pink{
      background: #F48FB1;
  }
  [light-purple], .light-purple{
      background: #CE93D8;
  }
  [light-green], .light-green{
      background: #C5E1A5;
  }
</style>
